import { filter, map, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { OnFieldChanged } from '../../../../../shared/modules/configurable-form/models/on-field-changed';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { getProjectProfiles } from '../../reducers/specification/specification.reducer';
import { getSpecificationForm, OrderBuilderState } from '../../../../reducers';
import { isBoolean, isString } from '@util';


@Injectable()
export class SetProjectPropertiesCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: any, formGroup: UntypedFormGroup): void {
    // Set profiles
    this.store
      .select(getSpecificationForm)
      .pipe(select(getProjectProfiles))
      .pipe(
        take(1),
        map((state) => {
          const projectProfile = state.find((profile) => profile.profileId === Number(value));

          if (projectProfile === undefined) {
            return null;
          }

          return projectProfile.project.projectProperties;
        }),
        filter((properties) => properties !== null),
      )
      .subscribe((projectProperties) => {
        for (const key of Object.keys(projectProperties)) {
          const projectProperty = projectProperties[key];

          if (formGroup.get(key) === null) {
            continue;
          }

          if (isBoolean(projectProperty)) {
            formGroup.get(key).patchValue(projectProperty);
            continue;
          }

          if (isString(projectProperty) && !isNaN(parseFloat(projectProperty))) {
            formGroup.get(key).setValue(parseFloat(projectProperty));
            continue;
          }

          // set everything form project props as Code (example: unloadTypeCode)
          formGroup.get(key).patchValue(projectProperty[key + 'Code']);
        }
      });
  }
}
